import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LibraryState } from '../reducers/library.reducer';
import { LIBRARY_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<LibraryState>(LIBRARY_FEATURE_KEY);

export const selectLoaded = createSelector(selectState, (state: LibraryState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: LibraryState) => state.loading);
export const selectLibrary = createSelector(selectState, (state: LibraryState) => state.library);
